import React from 'react'

import menuService from '../Service/menuService'
// import Cari_Obat from '../CariObat/modalSearch'
import { config } from '../Config/config'
import Cari_Doctor from '../Doctor/index'



export default class Menu extends React.Component {
    constructor() {
        super()
        this.state = {
            List:[],
            ListM: [],
            ListT: [],
            displayObat: "none",
            showModalCari: false,
            showModalDoctor:false
        }
    }

    showModal = () => {
        this.setState({
            showModalCari: true
        })
    }

    showModalDoctor =()=>{
        this.setState({
            showModalDoctor:true
        })
    }

    cancelModal = () => {
        this.setState({
            showModalCari: false,
            showModalDoctor:false
        })
    }


    loadList = async () => {
        const respon = await menuService.getByCode(localStorage.getItem(config.role))
        const responM = await menuService.getByCodeM(localStorage.getItem(config.role))
        const responT = await menuService.getByCodeT(localStorage.getItem(config.role))
        if (responM.success) {
            this.setState({
                List : respon.result,
                ListM: responM.result,
                ListT: responT.result
            })
        }
        console.log(responM.result)
        console.log(responT.result)
    }

    componentDidMount() {
        this.loadList()
        console.log(localStorage.getItem(config.role))
        console.log(localStorage.getItem(config.biodata_id))
    }

    render() {
        const { ListM, ListT, displayObat,List } = this.state
        return (


            <div class="container">
                {/* <div class="row">
                    {
                        ListM.map(data => {
                            return (
                                <div class="col-3">
                                    <a href={data.url}>
                                        <div class="card kartu shadow p-3 mb-5 bg-body rounded">
                                            <img class="rounded-circle mx-auto d-block mt-4" src={data.big_icon} width="100" alt="Admin" />
                                            <div class="card-body">
                                                <h5 class="card-title text-center">{data.nama}</h5>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            )
                        })
                    }
                </div> */}

                <div class="row">
                    {
                        List.map(data => {
                            return (
                                <div class="col-3">
                                    <a href={data.url}>
                                        <div class="card kartu shadow p-3 mb-5 bg-body rounded">
                                            <img class="rounded-circle mx-auto d-block mt-4" src={data.big_icon} width="100" alt="Admin" />
                                            <div class="card-body">
                                                <h5 class="card-title text-center">{data.nama}</h5>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            )
                        })
                    }
                    {localStorage.getItem(config.role) == "ROLE_PASIEN" ?
                        <>
                            <div class="col-3">
                                {/* <a href="javascript:void(0)" onClick={this.showModal}> */}
                                <a href="javascript:void(0)">
                                    <div class="card kartu shadow p-3 mb-5 bg-body rounded">
                                        <img class="rounded-circle mx-auto d-block mt-4" src="assets/img/icon/search_black_48dp.svg" width="100" alt="Admin" />
                                        <div class="card-body">
                                            <h5 class="card-title text-center">Cari Obat</h5>
                                        </div>
                                    </div>
                                </a>
                            </div>

                            <div class="col-3">
                                <a href="javascript:void(0)" onClick={this.showModalDoctor}>
                                    <div class="card kartu shadow p-3 mb-5 bg-body rounded">
                                        <img class="rounded-circle mx-auto d-block mt-4" src="assets/img/icon/search_black_48dp.svg" width="100" alt="Admin" />
                                        <div class="card-body">
                                            <h5 class="card-title text-center">Cari Doctor</h5>
                                        </div>
                                    </div>
                                </a>
                            </div>

                        </>
                        :
                        <>
                        </>
                    }
                </div>
                {/* <Cari_Obat
                    showModalCari={this.state.showModalCari}
                    cancelModal={this.cancelModal}
                /> */}
                <Cari_Doctor 
                showModalDoctor={this.state.showModalDoctor}
                cancelModal={this.cancelModal}
                />

            </div>

        )
    }
}